import IBaseLayoutProps from "@/interfaces/Props/IBaseLayoutProps";
import { Box } from "@mui/material";

const MainLayout = (props: IBaseLayoutProps) => {
  return (
    <Box
      component="main"
      sx={{
        width: "100%",
        flexGrow: 1,
        p: { xs: 2, sm: 3 }
      }}
    >
      {props.children}
    </Box>
  );
};

export default MainLayout;
